import { Trans } from "@lingui/macro";
import { PhoneOutlined, PinDropOutlined, TravelExploreOutlined } from "@mui/icons-material";
import { Box, Button, CardMedia, Link, Skeleton, Typography } from "@mui/material";
import { useState } from "react";
import { envAssets } from "../../../environment";

const WIDTH_WITHOUT_PADDING = { xs: '100%' };
const WIDTH_WITH_PADDING = { xs: '100%' };

export default function TourDrawerDetails({ clickedTourData }) {
    const [isImageLoaded, setIsImageLoaded] = useState(false)

    const style = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: { xs: 'center', sm: 'center' },
            mb: '10px',
            textAlign: { xs: 'left', sm: 'unset' },
        },
        icons: {
            mr: 2,
            fontSize: '1.5rem',
            color: 'text.secondary'
        },
    };

    return (
        <Box sx={{ width: WIDTH_WITHOUT_PADDING }}>
            <Box>
                {clickedTourData?.image &&
                    <CardMedia
                        width={WIDTH_WITHOUT_PADDING}
                        sx={{ display: !isImageLoaded ? 'none' : 'initial', height: { xs: '210px !important', lg: '220px !important', xl: '280px !important' } }}
                        onLoad={(e) => { setIsImageLoaded(true); }}
                        component="img"
                        image={clickedTourData?.image}
                        alt={clickedTourData?.image}
                    />
                }
                {((clickedTourData?.image && !isImageLoaded) || !clickedTourData?.image) &&
                    <Box sx={{ position: "relative" }}>
                        <Skeleton variant="rectangular" sx={{ width: WIDTH_WITHOUT_PADDING, height: { xs: 210, lg: 220, xl: 280 } }} />
                        <CardMedia
                            loading="lazy"
                            component="img"
                            sx={{ filter: 'grayscale(50%)', position: 'absolute', top: 0, bottom: 0, height: '70% !important', objectFit: 'contain', width: '100%', margin: 'auto', py: 5 }}
                            image={envAssets('images/grape-img.png')}
                            alt={'logo'}
                        />
                    </Box>
                }
            </Box>
            <Box maxWidth={WIDTH_WITH_PADDING} p={3} height={'auto'}>
                <Box px={1} >
                    {/* <Box pr={1}> */}
                    <Typography variant="h4" fontSize={{ xs: '1.35rem', md: '1.45rem', xl: '1.75rem' }} fontFamily="Playfair Display" >{clickedTourData?.title}</Typography>
                    <Typography color={"text.secondary"} fontWeight={300} variant="subtitle2" sx={{ fontSize: { xs: 14, xl: 18 } }}>{clickedTourData?.typeTitle}</Typography>
                    {/* </Box> */}
                    {/* <Box>
                        {clickedTourData?.type !== 'nature' &&
                            <CardMedia
                                width={80} height={100}
                                loading="lazy"
                                component="img"
                                sx={{ objectFit: 'contain', width: 80 }}
                                image={clickedTourData?.logo}
                                alt={clickedTourData?.logo}
                            />}
                    </Box> */}
                </Box>
                <Box px={1} py={2} display={"flex"} justifyContent={"center"} flexDirection={"column"}>
                    {clickedTourData?.city &&
                        <Box sx={style.container}>
                            <PinDropOutlined sx={style.icons} />
                            <Typography variant="subtitle2" fontWeight={300} sx={{ fontSize: { xs: 14, xl: 18 } }}>{clickedTourData?.city}{clickedTourData?.state && `, ${clickedTourData?.state}`}{clickedTourData?.address && `, ${clickedTourData?.address}`}</Typography>
                        </Box>
                    }
                    {/* {clickedTourData?.hours &&
                        <Box sx={style.container}>
                            <AlarmOutlined sx={style.icons} />
                            <Typography variant="subtitle2" sx={{ fontSize: { xs: 16, xl: 18 } }}>{clickedTourData?.hours}</Typography>
                        </Box>
                    } */}
                    {clickedTourData?.phone &&
                        <Box sx={style.container}>
                            <PhoneOutlined sx={style.icons} />
                            <Typography variant="subtitle2" fontWeight={300} sx={{ fontSize: { xs: 14, xl: 18 } }}>{clickedTourData?.phone}</Typography>
                        </Box>
                    }
                    {clickedTourData?.url &&
                        <Box sx={style.container}>
                            <TravelExploreOutlined sx={style.icons} />
                            <Typography variant="subtitle2" fontWeight={300}
                                component={Link}
                                href={clickedTourData?.url} target={'_blank'}
                                to={clickedTourData?.url} sx={{ cursor: 'pointer', wordBreak: 'break-word', fontSize: { xs: 14, xl: 18 } }}>
                                {clickedTourData?.url}
                            </Typography>
                        </Box>
                    }
                </Box>
                {clickedTourData?.permalink &&
                    <Box display={"flex"} justifyContent={"center"}>
                        <Button component={Link} target="_parent" href={clickedTourData?.permalink} sx={{ width: '100%', bgcolor: '#8F1E1A', ':hover': { bgcolor: '#651512' }, color: 'white', py: { xs: 0.7, xl: 1 }, fontSize: { xs: 14, xl: 16 } }} variant="contained"><Trans>научи повече</Trans></Button>
                    </Box>
                }
            </Box>
        </Box>
    )
}